import { render } from "./EmployeesView.vue?vue&type=template&id=08eb0488&scoped=true"
import script from "./EmployeesView.vue?vue&type=script&lang=js"
export * from "./EmployeesView.vue?vue&type=script&lang=js"

import "./EmployeesView.vue?vue&type=style&index=0&id=08eb0488&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08eb0488"]])

export default __exports__